import React, { useState } from "react";
import { Row, Col } from "reactstrap";

import PageViews from "./components/FacebookAnalytics/PageViews";
import PageVideos from "./components/FacebookAnalytics/PageVideos";
import PageReactios from "./components/FacebookAnalytics/PageReactios";
import PageFollows from "./components/FacebookAnalytics/PageFollows";
import PageVisits from "./components/FacebookAnalytics/PageVisits";
import PageAnalytics from "./components/FacebookAnalytics/PageAnalytics";
import PageImpressions from "./components/FacebookAnalytics/PageImpressions";
import Platforms from "./components/Platforms";
import Widget from "../../components/Widget";

import style from "./Dashboard.module.scss";
import "../widgets/Widgets.scss";

const Dashboard = () => {
  const [counters, setCounters] = useState([]);

  const [loading, setLoading] = useState(false);

  return (
    <div className={style.root}>
      {/* Start First Row */}
      <Row>
        <Col xl={4} lg={6} md={6} xs={12} className="colCustom40">
          <Row>
            <Col xs={12}>
              <Widget>
                <div className="clearfix height150 flexCenter">
                  <img src="https://www.emiratesauction.com/assets/NewHeaderRevamp2Icons/logo.svg" />
                </div>
              </Widget>
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={6} xs={12}>
              <PageViews />
            </Col>
            <Col xl={6} lg={6} md={6} xs={12}>
              <PageFollows />
            </Col>
          </Row>
        </Col>
        <Col xl={8} lg={6} md={6} xs={12} className="colCustom80">
          <PageVisits />
        </Col>
      </Row>
      {/* End First Row */}

      {/* Start Second Row  */}
      <Row>
        <Col xl={4} lg={4} md={6} xs={12} className="colCustom40">
          <Row>
            <Col xl={6} lg={4} md={6} xs={12}>
              <PageVideos />
            </Col>
            <Col xl={6} lg={4} md={6} xs={12}>
              <PageReactios
                counters={counters}
                setCounters={setCounters}
                loading={loading}
                setLoading={setLoading}
              />
            </Col>
          </Row>
          <Row>
            <Col xl={6} lg={6} md={12} xs={12}>
              <PageAnalytics />
            </Col>
            <Col xl={6} lg={6} md={12} xs={12}>
              <PageImpressions />
            </Col>
          </Row>
        </Col>
        <Col xl={8} lg={4} md={6} xs={12} className="colCustom80">
          <Platforms />
        </Col>
      </Row>

      {/* End Second Row */}
    </div>
  );
};

export default Dashboard;
